<template>
  <PageTemplate>
    <div class="element-box">
      <h6 class="element-header">
        {{ $t('ai_document_scan.title') }}
      </h6>
      <div class="element-content">
        <BaseDropzone v-model="files" :text="$t('ai_document_scan.label')"/>

        <div class="border-bottom py-3 text-center mb-5">
          <button
              :disabled="!files.length || isLoading"
              @click="documentScan"
              class="btn btn-primary"
              data-toggle="tooltip"
              data-placement="top"
              :title="!files.length ? 'keine Dateien' : ''">{{ $t('ai_document_scan.button_label') }}
            <span v-if="isLoading" class="spinner-border spinner-border-sm ml-1" role="status"
                  aria-hidden="true"></span>
          </button>
        </div>

        <h5 class="form-header text-center">{{ $t('ai_document_scan.analyzed_result') }}s</h5>
        <div v-if="documentData" class="row mt-4">
          <div class="col-8">

            <!-- CLIENT SECTION -->
            <div class="border rounded py-1 px-2 bg-lighter">
              <h6 class="mb-0">
                Informationen zu Kostenträgern (
                {{ documentData?.clientData && documentData?.clientData.length }}
                Kostenträger im System gefunden )
              </h6>
            </div>


            <!--            {{ numberOfClientFoundInSystem }} {{ clientData$.$errors }}-->
            <div class="mt-3 pl-2">
              <SelectVue
                  classFormGroup="col-6 px-0"
                  v-if="numberOfClientFoundInSystem > 1"
                  v-model="clientData"
                  :options="documentData?.clientData.data"
                  :required="true"
                  label='Kostenträger'
                  placeholder="Wählen Sie Kostenträger"
                  :validation="clientData$?.id"
                  :messages="clientData$?.id?.required?.$message"/>

              <div class="d-flex align-items-left mb-1">
                <span style="width: 150px; margin-right: 15px; font-weight: bold;">Kundennummer:</span>
                <span>{{ clientData.customerNumber }}</span>
              </div>
              <div class="d-flex align-items-left mb-1">
                <span style="width: 150px; margin-right: 15px; font-weight: bold;">Abrechnungsstelle:</span>
                <span>{{ clientData.registrationOffice }}</span>
              </div>
              <div class="d-flex align-items-left mb-1">
                <span style="width: 150px; margin-right: 15px; font-weight: bold;">Kostenträger:</span>
                <span>{{ clientData?.name }}</span>
              </div>

              <div class="d-flex align-items-left mb-1">
                <span style="width: 150px; margin-right: 15px; font-weight: bold;">Ort:</span>
                <span>{{ clientData.city }}</span>
              </div>

              <div class="d-flex align-items-left mb-1">
                <span style="width: 150px; margin-right: 15px; font-weight: bold;">PLZ:</span>
                <span>{{ clientData.zip }}</span>
              </div>
            </div>


            <!-- UNEMPLOYED DATA -->
            <div class="border rounded py-1 px-2 bg-lighter mt-5">
              <h6 class="mb-0">
                Kundeninformationen ( {{ numberOfUnemployedFoundInSystem }} Kunde im System gefunden )
              </h6>
            </div>

            <!-- Unemployed not found in system (Create new one ) -->
            <div v-if="!documentData?.unemployedData?.foundInSystem" class="d-flex flex-wrap mt-3 pl-1">
              <BaseInput v-model="unemployedData.customerNumber"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="JC / AA Nummer:"/>

              <BaseInput v-model="unemployedData.firstName"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Vorname:"
                         :required=true
                         :validation="unemployedData$?.firstName"
                         :messages="unemployedData$?.firstName?.required?.$message"/>

              <BaseInput v-model="unemployedData.lastName"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Nachname:"
                         :required=true
                         :validation="unemployedData$?.lastName"
                         :messages="unemployedData$?.lastName?.required?.$message"/>

              <BaseInput v-model="unemployedData.aaNumber"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Straße:"
                         :required=true
                         :validation="unemployedData$?.aaNumber"
                         :messages="unemployedData$?.aaNumber?.required?.$message"/>

              <BaseInput v-model="unemployedData.address"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="PLZ:"
                         :required=true
                         :validation="unemployedData$?.address"
                         :messages="unemployedData$?.address?.required?.$message"/>

              <BaseInput v-model="unemployedData.city"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Ort:"
                         :required=true
                         :validation="unemployedData$?.city"
                         :messages="unemployedData$?.city?.required?.$message"/>

              <Datepicker v-model="unemployedData.birthDate"
                          classFormGroup="col-lg-4 col-md-6 col-sm-12"
                          :required="true"
                          label="Geburtsdatum"
                          :validation="unemployedData$?.birthDate"
                          :messages="unemployedData$?.birthDate?.required?.$message"/>

              <BaseInput v-model="unemployedData.placeOfBirth"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Geburtsort:"
                         :required=true
                         :validation="unemployedData$?.placeOfBirth"
                         :messages="unemployedData$?.placeOfBirth?.required?.$message"/>

              <SelectVue v-model="unemployedData.gender"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         :options="genders"
                         :is-clear="true"
                         :required="true"
                         :label="$t('general.gender')"
                         :validation="unemployedData$.gender"
                         :messages="unemployedData$.gender.required.$message"/>
            </div>

            <!-- Unemployed found in system -->
            <div v-else class="d-flex flex-wrap mt-3 pl-2">
              <SelectVue
                  v-if="numberOfUnemployedFoundInSystem > 1"
                  v-model="unemployedData"
                  :required="true"
                  classFormGroup="col-6 px-0"
                  :options="documentData?.unemployedData.data"
                  placeholder="Kunden auswählen"
                  label="Kunde"
                  :validation="unemployedData$?.id"
                  :messages="unemployedData$?.id?.required?.$message"/>
              <div class="col-lg-8 col-md-6 col-sm-12" v-if="unemployedData?.deleted">
                <p class="text-danger font-weight-bolder">Dieser Kunde ist gelöscht</p>
              </div>

              <div class="row mb-3 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Kundennummer:</h6>
                    <span>{{ unemployedData?.customerNumber }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Vorname:</h6>
                    <span>{{ unemployedData?.firstName }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Nachname:</h6>
                    <span>{{ unemployedData?.lastName }}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">JC / AA Nummer:</h6>
                    <span>{{ unemployedData?.aaNumber }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Straße:</h6>
                    <span>{{ unemployedData?.address }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Ort:</h6>
                    <span>{{ unemployedData?.city }}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-2 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Geburtsdatum:</h6>
                    <span>{{ unemployedData.birthDate }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Geburtsort:</h6>
                    <span>{{ unemployedData.placeOfBirth }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Geschlecht:</h6>
                    <span>{{ unemployedData.gender }}</span>
                  </div>
                </div>
              </div>
            </div>


            <!-- OFFICE SECTION -->
            <div class="border rounded py-1 px-2 bg-lighter mt-5">
              <h6 class="mb-0 mt-0">
                Standort information ( {{ numberOfOfficeFoundInSystem }} Standort im System gefunden )
              </h6>
            </div>

            <!-- Office not found in system (Create new one )-->
            <div v-if="!documentData?.officeData?.foundInSystem" class="d-flex flex-wrap mt-3 pl-2">
              <BaseInput v-model="officeData.name"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Bezeichnung:"
                         :required=true
                         :validation="officeData$?.name"
                         :messages="officeData$?.name?.required?.$message"/>

              <BaseInput v-model="officeData.address"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Straße:"
                         :required=true
                         :validation="officeData$?.address"
                         :messages="officeData$?.address?.required?.$message"/>

              <BaseInput v-model="officeData.zip"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="PLZ:"
                         :required=true
                         :validation="officeData$?.zip"
                         :messages="officeData$?.zip?.required?.$message"/>

              <BaseInput v-model="officeData.city"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Stadt:"
                         :required=true
                         :validation="officeData$?.city"
                         :messages="officeData$?.city?.required?.$message"/>

              <BaseInput v-model="officeData.phone"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Telefonnummer:"/>

              <BaseInput v-model="officeData.email"
                         type="email"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Email:"/>

              <SelectedDropdown classFormGroup="col-lg-4 col-md-6 col-sm-12"
                                v-model="officeData.engagementType"
                                :options="officeEngagementTypesDropdown"
                                :required="true"
                                :label="$t('general.office_engagement_type')"
                                :placeholder="$t('placeholder.engagement_type')"
                                :validation="officeData$?.engagementType"
                                :messages="officeData$?.engagementType?.required?.$message"/>

              <SelectedDropdown classFormGroup="col-lg-4 col-md-6 col-sm-12"
                                v-model="officeData.type"
                                :options="officeTypesDropdown"
                                :required="true"
                                :label="$t('general.type')"
                                :placeholder="$t('placeholder.type')"
                                :validation="officeData$?.type"
                                :messages="officeData$?.type?.required?.$message"/>

              <BaseInput v-model="officeData.costCenter"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="KS1:"
                         :required=true
                         :validation="officeData$?.costCenter"
                         :messages="officeData$?.costCenter?.required?.$message"/>

              <SelectedDropdown classFormGroup="col-lg-4 col-md-6 col-sm-12"
                                v-model="officeData.federalState"
                                @update:modelValue="updateFederalState"
                                :options="federalStatesDropdown"
                                :required="false"
                                :label="$t('general.federal_state')"
                                :placeholder="$t('placeholder.select_federal_state')"
                                :validation="officeData$?.federalState"
                                :messages="officeData$?.federalState?.required?.$message"/>

              <BaseInput v-model="officeData.regionTranslation"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Region"
                         :required=true
                         :validation="officeData$.region"
                         :messages="officeData$.region.required.$message"
                         readonly/>

              <BaseInput v-model="officeData.colorCode"
                         classFormGroup="col-lg-2 col-md-6 col-sm-12"
                         label="Standortfarbe:"
                         :required=true
                         type="color"
                         :validation="officeData$?.color"
                         :messages="officeData$?.color?.required?.$message"/>
            </div>

            <!-- Office found in system -->
            <div v-else class="d-flex flex-wrap mt-3 pl-2">
              <SelectVue
                  v-if="numberOfOfficeFoundInSystem > 1"
                  label="Standort"
                  v-model="officeData"
                  classFormGroup="col-6 px-0"
                  :options="documentData?.officeData.data"
                  placeholder="Wählen Sie Standort"
                  :required="true"
                  :validation="officeData$?.id"
                  :messages="officeData$?.id?.required?.$message"/>

              <div class="col-lg-8 col-md-6 col-sm-12" v-if="officeData?.deleted">
                <p class="text-danger font-weight-bolder">Dieser Standort wurde gelöscht</p>
              </div>

              <div class="row mb-3 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Bezeichnung:</h6>
                    <span>{{ officeData?.name }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Ort:</h6>
                    <span>{{ officeData?.city }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Straße:</h6>
                    <span>{{ officeData?.address }}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Telefonnummer:</h6>
                    <span>{{ officeData?.phone }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">PLZ:</h6>
                    <span>{{ officeData?.zip }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Email:</h6>
                    <span>{{ officeData?.email }}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Extern/Intern:</h6>
                    <span>{{ officeData.engagementType }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Typ:</h6>
                    <span>{{ officeData.type }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Standortfarbe:</h6>
                    <span :style="{
                              padding: '6px',
                              width: '50px',
                              height: '20px',
                              display: 'block',
                              background: officeData.colorCode,
                              borderRadius: '3px'}">
                      </span>
                  </div>
                </div>
              </div>
              <div class="row mb-2 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Bundesland:</h6>
                    <span>{{ officeData.federalState }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">Region:</h6>
                    <span>{{ officeData.region }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="mr-2 font-weight-bolder">KS1:</h6>
                    <span>{{ officeData.costCenter }}</span>
                  </div>
                </div>
              </div>
            </div>


            <!-- COURSE SECTION -->
            <div class="border rounded py-1 px-2 bg-lighter mt-5">
              <h6 class="mb-0">
                Einzelcoachingmaßnahmen information ( {{ numberOfCoachingCourseFoundInSystem }}
                Einzelcoachingmaßnahmen im System gefunden )
              </h6>
            </div>

            <div class="mt-4 pl-2">
              <SelectVue
                  v-if="numberOfCoachingCourseFoundInSystem > 1"
                  v-model="coachingCourseData"
                  classFormGroup="col-6 px-0"
                  :required="true"
                  :options="documentData?.coachingCourseData.data"
                  label="Einzelcoachingmaßnahmen"
                  placeholder="Wählen Sie Einzelcoachingmaßnahmen"
                  :validation="coachingCourseData$?.id"
                  :messages="coachingCourseData$?.id?.required?.$message"/>

              <div class="d-flex align-items-left">
                <h6 class="font-weight-bolder mr-1">Bezeichnung:</h6>
                <span>{{ coachingCourseData.nameOfCoaching }}</span>
              </div>
              <div class="d-flex align-items-left">
                <h6 class="font-weight-bolder mr-1">Maßnahmenart:</h6>
                <span>{{ coachingCourseData.operationType }}</span>
              </div>
              <div class="d-flex align-items-left">
                <h6 class="font-weight-bolder mr-1">Maßnahmennummer:</h6>
                <span>{{ coachingCourseData.actionNumber }}</span>
              </div>
              <div class="d-flex align-items-left">
                <h6 class="font-weight-bolder mr-1">Dauer der Maßnahme (in Wochen):</h6>
                <span>{{ coachingCourseData.duration }}</span>
              </div>
              <div class="d-flex align-items-left">
                <h6 class="font-weight-bolder mr-1">Einheiten (Gesamtanzahl):</h6>
                <span>{{ coachingCourseData.units }}</span>
              </div>
            </div>

            <div class="border rounded py-1 px-2 bg-lighter mt-5">
              <h6 class="mb-0">
                Erstellen Sie ein neues Einzelcoaching
              </h6>
            </div>

            <div class="d-flex justify-content-between mt-4 pl-2">
              <Datepicker
                  label="Start"
                  classFormGroup="col-3"
                  v-model="coachingData.coachingStartDate"
                  :required="true"
                  :validation="coachingData$.coachingStartDate"
                  :messages="coachingData$.coachingStartDate.required.$message"/>
              <Datepicker
                  label="Ende"
                  classFormGroup="col-3"
                  v-model="coachingData.coachingEndDate"
                  :required="true"
                  :validation="coachingData$.coachingEndDate"
                  :messages="coachingData$.coachingEndDate.required.$message"/>
              <Datepicker
                  label="AVGS Gültigkeit -Start"
                  classFormGroup="col-3"
                  v-model="coachingData.coachingMaxDateOfFirstMeeting"
                  :required="true"
                  :validation="coachingData$.coachingMaxDateOfFirstMeeting"
                  :messages="coachingData$.coachingMaxDateOfFirstMeeting.required.$message"/>
              <Datepicker
                  label="AVGS Gültigkeit -Ende"
                  classFormGroup="col-3"
                  v-model="coachingData.coachingMinDateOfFirstMeeting"
                  :required="true"
                  :validation="coachingData$.coachingMinDateOfFirstMeeting"
                  :messages="coachingData$.coachingMinDateOfFirstMeeting.required.$message"/>
            </div>

            <!--            {{ clientData$.$errors }} {{ unemployedData$.$errors }} {{ officeData$.$errors }}-->
            <!--            {{ coachingCourseData$.$errors }}-->

            <ValidationErrorMessage
                :validationErrors="
                  (clientData$?.$errors.length ? clientData$.$errors :
                  unemployedData$?.$errors?.length ? unemployedData$.$errors :
                  officeData$?.$errors?.length ? officeData$.$errors :
                  coachingData$?.$errors || [])">
            </ValidationErrorMessage>

            <div class="d-flex justify-content-center mt-4 pt-3 border-top">
              <div class="btn btn-primary" @click="submitDocument">
                {{ t('general.button.save') }}
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="document-preview-container card">
              <div v-for="(item, index) in computedPdfUrls" :key="item.name">
                <div :class="{ 'mt-4': index > 0 }">{{ item.name }}</div>

                <input
                    type="range"
                    min="50"
                    max="150"
                    :value="zoomLevels[item.name] || 100"
                    @input="zoomLevels[item.name] = $event.target.value"
                />
                Zoom: {{ zoomLevels[item.name] || 100 }}%
                <iframe
                    :src="item.url"
                    height="600"
                    width="100%"
                ></iframe>
              </div>


              <!--              <div>-->
              <!--                <h6 class="text-center mt-2">{{ files[ 0 ].name }}</h6>-->
              <!--                <input type="range" min="50" max="150" v-model="zoom"/> Zoom: {{ zoom }}%-->
              <!--                <div>-->
              <!--                  <iframe-->
              <!--                      v-if="pdfUrls[0]"-->
              <!--                      height="600"-->
              <!--                      width="100%"-->
              <!--                      :src="computedPdfUrl"></iframe>-->
              <!--                </div>-->
              <!--&lt;!&ndash;                <div class="controls mt-2 mb-2 d-flex justify-content-center" style="gap: 30px;">&ndash;&gt;-->
              <!--&lt;!&ndash;                  <button class="btn btn-sm btn-primary">Vorherige</button>&ndash;&gt;-->
              <!--&lt;!&ndash;                  <span>Seite: <span>1</span> /<span>{{ pdfUrls.length }}</span></span>&ndash;&gt;-->
              <!--&lt;!&ndash;                  <button class="btn btn-sm btn-primary">Nächste</button>&ndash;&gt;-->
              <!--&lt;!&ndash;                </div>&ndash;&gt;-->

              <!--              </div>-->
            </div>
          </div>
        </div>
        <h6 v-else class="text-center">
          {{ $t('ai_document_scan.no_data_available_text') }}
        </h6>

      </div>
    </div>
  </PageTemplate>
</template>
<script setup>
import aiDocumentScanService from '@/api/AiDocumentScan';
import BaseDropzone from '@/components/base/BaseDropzone.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectedDropdown from '@/components/SelectDropdown.vue';
import SelectVue from '@/components/SelectVue.vue';
import ValidationErrorMessage from '@/components/ValidationErrorMessage.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import { requiredRule } from '@/shared/validators/validationRules';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import useVuelidate from '@vuelidate/core';
import { computed, onMounted, ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }           = useI18n();
const piniaEnumsState = piniaEnumsStore();
const { genders }     = computed(() => piniaEnumsState.enums).value;
const getEnums        = computed(() => piniaEnumsState.enums);

const isSubmitting                        = ref(false);
const files                               = ref([]);
const federalStatesDropdown               = ref([]);
const officeEngagementTypesDropdown       = ref([]);
const officeTypesDropdown                 = ref([]);
const regionsDropdown                     = ref([]);
const documentData                        = ref();
const clientData                          = ref({});
const numberOfClientFoundInSystem         = ref(0);
const unemployedData                      = ref({});
const numberOfUnemployedFoundInSystem     = ref(0);
const officeData                          = ref({});
const numberOfOfficeFoundInSystem         = ref(0);
const coachingCourseData                  = ref({});
const numberOfCoachingCourseFoundInSystem = ref(0);
const coachingData                        = ref({
  coachingStartDate: null,
  coachingEndDate: null,
  coachingMinDateOfFirstMeeting: null,
  coachingMaxDateOfFirstMeeting: null,
});

watchEffect(() => {
  coachingData.value.clientId                      = clientData.value?.id || null;
  coachingData.value.coachingStartDate             = coachingData.value.coachingStartDate || documentData.value?.finalData.StartDate || null;
  coachingData.value.coachingEndDate               = coachingData.value.coachingEndDate || documentData.value?.finalData.StartDate || null;
  coachingData.value.coachingMinDateOfFirstMeeting = coachingData.value.coachingMinDateOfFirstMeeting || documentData.value?.finalData.coachingMaxDateOfFirstMeeting || null;
  coachingData.value.coachingMaxDateOfFirstMeeting = coachingData.value.coachingMaxDateOfFirstMeeting || documentData.value?.finalData.coachingMinDateOfFirstMeeting || null;
});

const rulesClientData         = ref({});
const rulesCourseCoachingData = ref({});

const rulesOfficeData = ref({
  name: requiredRule(t),
  address: requiredRule(t),
  zip: requiredRule(t),
  city: requiredRule(t),
  engagementType: requiredRule(t),
  type: requiredRule(t),
  colorCode: requiredRule(t),
  federalState: requiredRule(t),
  costCenter: requiredRule(t),
  region: requiredRule(t),
});

const rulesUnemployedData = ref({
  firstName: requiredRule(t),
  lastName: requiredRule(t),
  aaNumber: requiredRule(t),
  address: requiredRule(t),
  city: requiredRule(t),
  birthDate: requiredRule(t),
  placeOfBirth: requiredRule(t),
  gender: requiredRule(t),
});

const rulesCoachingData = ref({
  clientId: requiredRule(t),
  coachingStartDate: requiredRule(t),
  coachingEndDate: requiredRule(t),
  coachingMinDateOfFirstMeeting: requiredRule(t),
  coachingMaxDateOfFirstMeeting: requiredRule(t),
});

const computedClientRules         = computed(() => rulesClientData.value);
const computedUnemployedRules     = computed(() => rulesUnemployedData.value);
const computedOfficeRules         = computed(() => rulesOfficeData.value);
const computedCoachingCourseRules = computed(() => rulesCourseCoachingData.value);
const computedRulesCoachingData   = computed(() => rulesCoachingData.value);

const clientData$         = useVuelidate(computedClientRules, clientData);
const unemployedData$     = useVuelidate(computedUnemployedRules, unemployedData);
const officeData$         = useVuelidate(computedOfficeRules, officeData);
const coachingCourseData$ = useVuelidate(computedCoachingCourseRules, coachingCourseData);
const coachingData$       = useVuelidate(computedRulesCoachingData, coachingData);

const isLoading = ref(false);
const pdfUrls   = ref([]);
const zoom      = ref(50);

//const computedPdfUrl = computed(() => `${URL.createObjectURL(files.value[ 0 ])}#zoom=${zoom.value}`);

const zoomLevels = ref({});

const computedPdfUrls = computed(() => {
  if (!files.value || files.value.length === 0) return [];

  return files.value.map(file => {
    const zoom = zoomLevels.value[file.name] || 100;
    return {
      name: file.name,
      url: URL.createObjectURL(file) + `#zoom=${zoom}`
    };
  });
});

const documentScan = async () => {

  resetRulesForIds();

  const formData = new FormData();

  isLoading.value = true;

  if (files.value?.length) {
    for (const item of files.value) {
      formData.append('documents[]', item);
      pdfUrls.value.push(URL.createObjectURL(item));
    }
  }

  try {
    const { data } = await aiDocumentScanService.aiDocumentScan(formData);

    documentData.value = data.data;

    // Client
    const clientScanData              = data.data?.clientData;
    numberOfClientFoundInSystem.value = clientScanData.count;

    if (numberOfClientFoundInSystem.value === 1) {
      clientData.value = clientScanData.data[ 0 ].value;
    }
    if (numberOfClientFoundInSystem.value > 1) {
      rulesClientData.value = {
        ...rulesClientData.value,
        id: requiredRule(t),
      };
    } else {
      rulesClientData.value = {
        ...rulesClientData.value,
        id: '',
      };
    }

    // Unemployed
    const unemployedScanData = data.data?.unemployedData;
    const countUnemployed    = unemployedScanData.count;

    if (unemployedScanData.foundInSystem) {
      numberOfUnemployedFoundInSystem.value = countUnemployed;
    }
    if (countUnemployed === 1) {
      unemployedData.value = unemployedScanData.data[ 0 ].value;
    }
    if (numberOfUnemployedFoundInSystem.value > 1) {
      rulesUnemployedData.value = {
        ...rulesUnemployedData.value,
        id: requiredRule(t),
      };
    } else {
      rulesUnemployedData.value = {
        ...rulesUnemployedData.value,
        id: '',
      };
    }

    // Office
    const officeScanData = data.data?.officeData;
    const countOffice    = officeScanData.count;

    if (officeScanData.foundInSystem) {
      numberOfOfficeFoundInSystem.value = countOffice;
    }
    if (countOffice === 1) {
      officeData.value = officeScanData.data[ 0 ].value;
    }
    if (numberOfOfficeFoundInSystem.value > 1) {
      rulesOfficeData.value = {
        ...rulesOfficeData.value,
        id: requiredRule(t),
      };
    } else {
      rulesOfficeData.value = {
        ...rulesOfficeData.value,
        id: '',
      };
    }

    // Coaching course
    const coachingCourseScanData = data.data?.coachingCourseData;
    const countCoachingCourse    = coachingCourseScanData.count;

    numberOfCoachingCourseFoundInSystem.value = countCoachingCourse;
    if (countCoachingCourse === 1) {
      coachingCourseData.value = coachingCourseScanData.data[ 0 ].value;
    }
    if (countCoachingCourse === 2) {
      rulesCourseCoachingData.value = {
        ...rulesCourseCoachingData.value,
        id: requiredRule(t),
      };
    } else {
      rulesCourseCoachingData.value = {
        ...rulesCourseCoachingData.value,
        id: '',
      };
    }

  } catch (error) {
    await ErrorToast(error);
  } finally {
    isLoading.value = false;
  }
};

const submitDocument = async () => {
  CloseToast();

  if (numberOfClientFoundInSystem.value > 1) {
    clientData$.value.$touch();
    if (clientData$.value.$invalid) {
      return;
    }
  }
  if ((!documentData?.value.unemployedData.foundInSystem) || (numberOfUnemployedFoundInSystem.value > 1)) {
    unemployedData$.value.$touch();
    if (unemployedData$.value.$invalid) {
      return;
    }
  }
  if ((!documentData?.value.officeData.foundInSystem) || (numberOfOfficeFoundInSystem.value > 1)) {
    officeData$.value.$touch();
    if (officeData$.value.$invalid) {
      return;
    }
  }
  if (numberOfCoachingCourseFoundInSystem.value > 1) {
    coachingCourseData$.value.$touch();
    if (coachingCourseData$.value.$invalid) {
      return;
    }
  }

  coachingData$.value.$touch();
  if (coachingData$.value.$invalid) {
    return;
  }

  const submittedData = {
    clientData: clientData.value,
    officeData: officeData.value,
    unemployedData: unemployedData.value,
    coachingCourseData: coachingCourseData.value,
    coachingData: coachingData.value,
  };

  try {
    await aiDocumentScanService.createPrivateCoachingFromDocumentScan(submittedData);

    await router.push({ name: 'clientList' });

    isSubmitting.value = false;
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }

};

const updateFederalState = (newValue) => {
  const regionFromFederalState = regionsDropdown.value.find(regionDropdown => regionDropdown.federal_state_key === newValue);

  if (regionFromFederalState) {
    officeData.value.region            = regionFromFederalState.key;
    officeData.value.regionTranslation = regionFromFederalState.value;
  } else {
    officeData.value.region            = '';
    officeData.value.regionTranslation = '';
  }
};

function resetRulesForIds() {
  rulesClientData.value         = {
    ...rulesClientData.value,
    id: '',
  };
  rulesUnemployedData.value     = {
    ...rulesUnemployedData.value,
    id: '',
  };
  rulesOfficeData.value         = {
    ...rulesOfficeData.value,
    id: '',
  };
  rulesCourseCoachingData.value = {
    ...rulesCourseCoachingData.value,
    id: '',
  };
}

onMounted(async () => {
  federalStatesDropdown.value         = getEnums.value?.federalStates || [];
  officeTypesDropdown.value           = getEnums.value?.officeTypes || [];
  officeEngagementTypesDropdown.value = getEnums.value?.officeEngagementTypes || [];
  regionsDropdown.value               = getEnums.value?.regions || [];
});


</script>
<style scoped>
</style>